

<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>Vip用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索：">
        <el-select size="small" v-model="formInline.roleId" clearable="" placeholder="请选择角色名称">
          <el-option  v-for="roleitem in roleOption" :key="roleitem.id"
              :label="roleitem.title"
              :value="roleitem.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="用户名">
        <el-input size="small" clearable v-model="formInline.name" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="身份证号">
        <el-input size="small" clearable v-model="formInline.idNum" placeholder="请输入身份证号"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input size="small" clearable v-model="formInline.phone" placeholder="清输入手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
        <!-- <el-button size="small" type="primary" @click="handleunit()">部门设置</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="50">
      </el-table-column>
      <el-table-column align="center" sortable prop="name" label="用户名" width="120">
      </el-table-column>
      <el-table-column align="center" prop="address" label="地址" width="120">
      </el-table-column>
      <el-table-column align="center" prop="phone1" label="账号" width="120">
      </el-table-column>

      <el-table-column align="center" prop="phone2" label="手机号" width="120">
      </el-table-column>
      <el-table-column align="center" prop="sex" label="性别" min-width="50">
      </el-table-column>
      <el-table-column align="center" prop="idNum" label="身份证号" min-width="50">
      </el-table-column>
      <el-table-column align="center" prop="amount" label="金额" min-width="50">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
  </div>
</template>

<script>
import md5 from 'js-md5'
// 导入请求方法
import {
  getVipUserList,
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: false, //switch开启
      fshow: true, //switch关闭
      loading: false, //是显示加载
      title: '添加用户',
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示
      // 编辑与添加
      editForm: {
        nickName: '',
        userName: '',
        state:1,
        roleId: '',
        phone: '',
        sex: '',
        pwd:'',
      },
      pwdIsDisabled:false,
      seen: '',
      pwdType: 'password',
      openeye: require('../../assets/svg/yanjing-zhengyan.svg'),
      offeye: require('../../assets/svg/yanjing-biyan.svg'),
      // 选择数据
      roleOption:[],
      selectdata: [],
      // rules表单验证
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        nickName: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
        roleId: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            // pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
            pattern:/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            required: true,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        // userEmail: [
        //   { required: true, message: '请输入邮箱', trigger: 'blur' },
        //   {
        //     pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
        //     required: true,
        //     message: '请输入正确的邮箱',
        //     trigger: 'blur'
        //   }
        // ],
        sex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
      },
      // 删除用户
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      // 重置密码
      resetpsd: {
        userId: '',
        token: localStorage.getItem('logintoken')
      },
      // 用户下线
      offline: {
        token: localStorage.getItem('logintoken')
      },
      // 请求数据参数
      formInline: {
        page: 1,
        limit: 10,
      },
      //用户数据
      userData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      // 获取用户列表
      console.log(parameter,'parameter');
      getVipUserList(parameter).then(res => {
        this.loading = false
        if (res.rsp_code !== 200) {
          this.$message({
            type: 'info',
            message: res.rsp_msg
          })
        } else {
          this.userData = res.body.records
          // 分页赋值
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.body.total
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.formInline.page=1
      this.getdata(this.formInline)
    },
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.unitparm.deptId = data.id
        this.unitparm.deptName = data.name
        //交叉点击节点
      } else {
      }
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },

    // 刷新缓存
    refreshCache(index, row) {
      userFlashCache(row.userName)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '刷新成功！'
            })
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('刷新失败，请稍后再试！')
        })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.eye{
    width: 18px;
    height: 20px;
    position: absolute;
    left: 93%;
    top: 30%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/vipuser.vue